export default __webpack_public_path__ + "static/media/logo16.9f537ef8.svg";